export default __webpack_public_path__ + "atomic/_patterns/02-molecules/apartment-teaser/_apartment-teaser.twig";